<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#68D389"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <span class="itemHeading">Employee List</span>
          <v-spacer></v-spacer>
          <v-flex pt-5 xl3 lg3 md3 pb-2 sm4 xs12 px-5 v-if="!hasTaken">
            <v-btn
              style="font-family: poppinsmedium"
              dark
              class="rounded-xl"
              block
              color="primary"
              to="/Admin/markAttendance"
              ><v-icon color="#ffffff">mdi-note-edit</v-icon>
              <span style="color:#ffffff">
                Take Attendance
              </span>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start v-if="employeeList">
          <v-flex xs12 align-self-center fill-height pa-4>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr class="poppinssemibold">
                    <th style="color:red !important" class="text-left">
                      Name
                    </th>
                    <th style="color:red !important" class="text-left">
                      Role
                    </th>
                    <th style="color:red !important" class="text-left">
                      <span>
                        Phone<span style="color:white">_</span>Number
                      </span>
                    </th>
                    <th style="color:red !important" class="text-left">
                      <span>
                        Actions
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in employeeList"
                    :key="i"
                    class="poppinsregular"
                  >
                    <td class="text-left">
                      <span v-if="item.userName">
                        {{ item.userName }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="text-left">
                      <span v-if="item.role">
                        {{ item.role }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="text-left">
                      <span v-if="item.phoneNumber">
                        {{ item.phoneNumber }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <v-layout wrap justify-start>
                        <v-flex xs12 sm3 align-self-center text-left px-2 py-2>
                          <v-btn
                            color="success"
                            style="font-family: poppinsmedium"
                            x-small
                            outlined
                            fab
                            dark
                            :to="'/Admin/viewEmployee?id=' + item._id"
                          >
                            <v-icon color="success">
                              mdi-eye-outline
                            </v-icon>
                            <!-- <span style="color:#000">View</span> -->
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 sm3 align-self-center text-left px-2 py-2>
                          <v-btn
                            color="cyan"
                            style="font-family: poppinsmedium"
                            x-small
                            outlined
                            fab
                            dark
                            :to="'/Admin/editEmployee?id=' + item._id"
                          >
                            <v-icon dark color="cyan">
                              mdi-pencil
                            </v-icon>
                            <!-- <span style="color:#000">Edit</span> -->
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 sm3 align-self-center text-left px-2 py-2>
                          <v-dialog
                            persistent
                            v-model="item.delete"
                            max-width="600px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                style="font-family: poppinsmedium"
                                fab
                                outlined
                                v-on="on"
                                v-bind="attrs"
                                color="error"
                              >
                                <!-- Delete -->
                                <v-icon color="error">
                                  mdi-trash-can-outline
                                </v-icon>
                              </v-btn>
                            </template>
                            <v-card tile class="pa-6">
                              <v-card-title class="poppinssemibold"
                                >Are you sure you want to delete this
                                Employee?</v-card-title
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  dark
                                  small
                                  @click="item.delete = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="error darken-1"
                                  dark
                                  small
                                  @click="
                                    (item.delete = false), deleteItem(item)
                                  "
                                  >Delete</v-btn
                                >
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- <v-card tile elevation="3" outlined>
              <v-layout wrap justify-center py-4 pa-2>
                <v-flex xs12 px-4 py-2 text-center>
                  <span style="font-family: poppinsbold;font-size:17px">{{ item.name }}</span>
                </v-flex>
                <v-flex xs12 px-4 py-0 text-center>
                 <i>
                    <span class="poppinssemibold" style="font-size:13px"> ( {{ item.type }} )</span>
                 </i>
                </v-flex>

                <v-flex xs12 py-4>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm6 align-self-center text-right px-2 py-2>
                  <v-btn
                    color="teal"
                    style="font-family: poppinsmedium"
                    small
                    block
                    class="rounded-xl"
                    dark
                    :to="'/Admin/editUnit?id=' + item._id"
                  >
                    <span style="color:#ffffff">Edit</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 align-self-center text-left px-2 py-2>
                  <v-dialog v-model="item.delete" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        style="font-family: poppinsmedium"
                        dark
                        block
                        class="rounded-xl"
                        v-on="on"
                        v-bind="attrs"
                        color="error"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                        >Are you sure you want to delete this
                        Unit?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItem(item)"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-card> -->
          </v-flex>
          <v-dialog v-model="editdialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Category</span>
              </v-card-title>
              <v-card-text>
                <v-layout>
                  <v-flex xs12 md12 lg12>
                    <v-text-field
                      v-model="editingitem.name"
                      label=" Category"
                      :rules="[rules.required]"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="getdData">
                  Close
                </v-btn>
                <v-btn
                  v-if="!flag"
                  color="blue darken-1"
                  text
                  @click="edit(editingitem._id)"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 pa-16>
            <span>
              No Employee found!
            </span>
          </v-flex>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#68D389"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: [],
      name: "",
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      flag: false,
      perPage: 4,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,

      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
      category: [],
      data: [],
      employeeList: null,
      hasTaken: false,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    currentPage() {
      this.getData()
    }
  },

  created() {
    this.initialize();
  },
  methods: {
    getdData() {
      this.editdialog = false;
      this.getData();
    },
    initialize() {
      this.admin = [];
    },

    deleteItem(cat) {
      var data = {};
      data["id"] = cat._id;
      axios({
        url: "/employee/remove",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;

            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/get/all/employeelist",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          page: 1,
          limit: 20,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.employeeList = response.data.data;

          this.hasTaken = response.data.hasTakenAttandance;

          this.totalData = response.data.totalLength;
          this.pages = Math.ceil(
            response.data.totalLength / response.data.limit
          );
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.name = null;
      this.dialog = false;
    },

    categoryadd() {
      var data = {};
      data["name"] = this.name;
      axios({
        url: "/category/add",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.name = null;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editcat(item) {
      this.editingitem = item;
      this.editdialog = true;
    },
    edit() {
      var data = {};
      data["id"] = this.editingitem._id;
      data["name"] = this.editingitem.name;
      axios({
        url: "/category/edit",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;

          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
